module.exports = __webpack_public_path__ + "static/media/foodCharity.af6141ee.png";